module.exports = __webpack_public_path__ + "img/11088037_L.327b2946.png";